export const errors = {
  common: {
    unknownError: "errors.unknownError",
    invalidEntity: "errors.invalidEntity",
    invalidId: "errors.invalidId",
    someRequiredPropertiesAreMissing: "errors.someRequiredPropertiesAreMissing",
    invalidEntityEmptyObject: "errors.invalidEntityEmptyObject",
    fetchMsProfileError: "errors.fetchMsProfileError",
    emptyApiResponse: "errors.emptyApiResponse",
    validationError: "errors.validationError",
    authenticationError: "errors.authenticationError",
    invalidResponseStatus: "errors.invalidResponseStatus",
    forbiddenResponseStatus: "errors.forbiddenResponseStatus",
    forbiddenResponseByPermission: "errors.forbiddenResponseByPermission",
    dashboardUnauthenticatedCardError:
      "errors.dashboardUnauthenticatedCardError",
    notFoundResponseStatus: "errors.notFoundResponseStatus",
    recordNotAvailable: "errors.recordNotAvailable",
    technicalProblemOccurred: "errors.technicalProblemOccurred",
    failedToFetchTableRows: "errors.failedToFetchTableRows",
    invalidEntityReturnedFromAPI: "errors.invalidEntityReturnedFromAPI",
    changedRejectedByUser: "errors.changedRejectedByUser",
    fetchNotAllowed: "errors.fetchNotAllowed",
    invalidCompanyId: "errors.invalidCompanyId",
    errorSavingToAPI: "errors.errorSavingToAPI",
    invalidAPIResponse: "errors.invalidAPIResponse",
    invalidExecutionResult: "errors.invalidExecutionResult",
    invalidDragData: "errors.invalidDragData",
    stationsNotRecountedSuccessfully: "errors.stationsNotRecountedSuccessfully",
    archiveRelationError: "errors.archiveRelationError",
    bulkArchiveRelationError: "errors.bulkArchiveRelationError",
    genericNoPermission: "errors.genericNoPermission",
    errorFetchingApiData: "errors.errorFetchingApiData",
    invalidResponse: "errors.invalidResponse",
    responseErrorStatus: "errors.responseErrorStatus",
    requestCanceled: "errors.requestCanceled",
    bulkFailToArchiveEntities: "errors.bulkFailToArchiveEntities",
    errorPerformingBulkAction: "errors.errorPerformingBulkAction",
    noIdsProvidedToBulkAction: "errors.noIdsProvidedToBulkAction",
    noRecordsFoundForBulkOperation: "errors.noRecordsFoundForBulkOperation",
    noSuppliersSelected: "errors.noSuppliersSelected",
    pageNotFound: "general.PAGE_NOT_FOUND",
    pageNotFoundDescription: "general.PAGE_NOT_FOUND_DESCRIPTION",
    returnToMainPage: "general.RETURN_TO_MAIN_PAGE",
    socketNotConnected: "errors.socketNotConnected",
    errorBulkUpdatingData: "errors.errorBulkUpdatingData",
    dontHavePermissionForBulkAction: "errors.dontHavePermissionForBulkAction",
    dontHavePermissionForAction: "errors.dontHavePermissionForAction",
    missingPermissionForEntity: "errors.missingPermissionForEntity",
    failedFetchSystemSettings: "errors.failedFetchSystemSettings",
    failedToFetchAuditLog: "errors.failedToFetchAuditLogList",
    internetConnectionUnstable: "errors.internetConnectionUnstable",
    internetConnectionIssue: "errors.internetConnectionIssue",
    fileIsNotSelected: "errors.fileIsNotSelected",
    invalidFileType: "errors.invalidFileType",
  },
  ride: {
    missingRide: "errors.missingRide",
    rideNotFound: "errors.rideNotFound",
    invalidRideId: "errors.invalidRideId",
    directionMismatch: "errors.directionMismatch",
    companyMismatch: "errors.companyMismatch",
    missingTokenRide: "errors.missingTokenRide",
    noMatchingPriceRate: "errors.noMatchingPriceRate",
    manualPriceClearedNoRateSetDraft: "errors.manualPriceClearedNoRateSetDraft",
    missingSourceRide: "errors.missingSourceRide",
    invalidRideStatus: "errors.invalidRideStatus",
    rideEditNewOnlyNotPermitted: "errors.rideEditNewOnlyNotPermitted",
    rideDatesNotWithinRange: "errors.rideDatesNotWithinRange",
    noNearbyStation: "errors.noNearbyStation",
    missingSupplier: "errors.missingSupplier",
    arriveAfterStart: "errors.arriveAfterStart",
    departAfterEnd: "errors.departAfterEnd",
    stationsMissingFromNewOrder: "errors.stationsMissingFromNewOrder",
    invalidCourseReferencedFromRide: "errors.invalidCourseReferencedFromRide",
    firstStationLocked: "errors.firstStationLocked",
    routingWaypointCannotBeRouteEndpoint:
      "errors.routingWaypointCannotBeRouteEndpoint",
    invalidStationIds: "errors.invalidStationIds",
    missingStation: "errors.missingStation",
    passengerPickupPastDropoff: "errors.passengerPickupPastDropoff",
    rideEmptyBetweenStations: "errors.rideEmptyBetweenStations",
    rideSwitchToDraft: "validation.softValidation.rideSwitchToDraft",
    notEnoughSpace: "errors.notEnoughSpace",
    rideDropStationsMismatch: "errors.rideDropStationsMismatch",
    shuttlePassengerMoveNotCompatible:
      "errors.shuttlePassengerMoveNotCompatible",
    invalidRideDragIdMismatch: "errors.invalidRideDragIdMismatch",
    invalidDragDropRideData: "errors.invalidDragDropRideData",
    invalidDragDropRideDataNoPassengersToDrop:
      "errors.invalidDragDropRideDataNoPassengersToDrop",
    invalidDropRide: "errors.invalidDropRide",
    invalidDropRideIdToPerformDragDrop:
      "errors.invalidDropRideIdToPerformDragDrop",
    invalidRideIDBadAPIResponse: "errors.invalidRideIDBadAPIResponse",
    stationNotMovedEmptyAPIResponse: "errors.stationNotMovedEmptyAPIResponse",
    validDropTargetForCreatingNewRide:
      "errors.validDropTargetForCreatingNewRide",
    invalidDragRideIdToPerformDragDrop:
      "errors.invalidDragRideIdToPerformDragDrop",
    cantDropToTheSameRide: "errors.cantDropToTheSameRide",
    cantDropToTheRideWithTheOppositeDirection:
      "errors.cantDropToTheRideWithTheOppositeDirection",
    cantDropToTheRideWithStatus: "errors.cantDropToTheRideWithStatus",
    cantDragRideWithStatus: "errors.cantDragRideWithStatus",
    invalidRideDate: "errors.invalidRideDate",
    cantDropToRideWithDifferentDate: "errors.cantDropToRideWithDifferentDate",
    cantDropToThePickupRideWithEndTimeOffset:
      "errors.cantDropToThePickupRideWithEndTimeOffset",
    cantDropToTheDropoffRideWithStartTimeOffset:
      "errors.cantDropToTheDropoffRideWithStartTimeOffset",
    mergeRidesCanceledDestinationStationsNotMatch:
      "errors.mergeRidesCanceledDestinationStationsNotMatch",
    mergeRidesCanceledOriginStationsNotMatch:
      "errors.mergeRidesCanceledOriginStationsNotMatch",
    invalidDragSourceData: "errors.invalidDragSourceData",
    invalidDragTargetData: "errors.invalidDragTargetData",
    invalidDragRideData: "errors.invalidDragRideData",
    invalidStationOrderPickupAfterDropoff:
      "errors.invalidStationOrderPickupAfterDropoff",
    cantReorderStationInvalidDragRideObject:
      "errors.cantReorderStationInvalidDragRideObject",
    errorReorderingStationRide: "errors.errorReorderingStationRide",
    reorderStationCanceledByUser: "errors.reorderStationCanceledByUser",
    errorUpdatingRideData: "errors.errorUpdatingRideData",
    invalidRideForReorder: "errors.invalidRideForReorder",
    removeFilterCanceledByUser: "errors.removeFilterCanceledByUser",
    cantReorderStationOfDifferentRides:
      "errors.cantReorderStationOfDifferentRides",
    failedUpdateRide: "errors.failedUpdateRide",
    didntFoundStationToUpdate: "errors.didntFoundStationToUpdate",
    invalidEditDTOWhileUpdatingStationAttributes:
      "errors.invalidEditDTOWhileUpdatingStationAttributes",
    failedFetchingTrackingDTOs: "errors.failedFetchingTrackingDTOs",
    failedFetchingBookingDTOs: "errors.failedFetchingBookingDTOs",
    sameIndexReturnedNoNeedToReorder: "errors.sameIndexReturnedNoNeedToReorder",
    invalidDataForRecountNoStationOfDate:
      "errors.invalidDataForRecountNoStationOfDate",
    noPassengersChosenToRemoveFromRide:
      "errors.noPassengersChosenToRemoveFromRide",
    passengersToRemoveNotFoundInRide: "errors.passengersToRemoveNotFoundInRide",
    noValidPassengersFoundToCreateRide:
      "errors.noValidPassengersFoundToCreateRide",
    noStationsChosenToRemoveFromRide: "errors.noStationsChosenToRemoveFromRide",
    cantRemovePassengersFromRideInvalidRideId:
      "errors.cantRemovePassengersFromRideInvalidRideId",
    errorRemovingPassengers: "errors.errorRemovingPassengers",
    errorRemovingPassengersInvalidAPI:
      "errors.errorRemovingPassengersInvalidAPI",
    failedToUpdateRides: "errors.failedToUpdateRides",
    passengerNotAdded: "errors.passengerNotAdded",
    rideNotCreatedInvalidAPI: "errors.rideNotCreatedInvalidAPI",
    failedCreateRide: "errors.failedCreateRide",
    rebuildRouteFailed: "errors.rebuildRouteFailed",
    rideRebuildFailed: "errors.rideRebuildFailed",
    noInitialDateInRide: "errors.noInitialDateInRide",
    noStationToRebuild: "errors.noStationToRebuild",
    stationsWereNotRecountedSuccessfully:
      "errors.stationsWereNotRecountedSuccessfully",
    failedFetchingRides: "errors.failedFetchingRides",
    noPassengersSelectedForUpdate: "errors.noPassengersSelectedForUpdate",
    formNotValidSkipDryCheckingRide: "errors.formNotValidSkipDryCheckingRide",
    stationNotAdded: "errors.formNotValidSkipDryCheckingRide",
    stationsNotRecountedSuccessfully: "errors.stationsNotRecountedSuccessfully",
    invalidRideEditingSnapshot: "errors.invalidRideEditingSnapshot",
    stationDoesntHavePassengers: "errors.stationDoesntHavePassengers",
    removingStationFromRideCanceledByUser:
      "errors.removingStationFromRideCanceledByUser",
    notValidPassengersToRemove: "errors.notValidPassengersToRemove",
    removingPassengersFromRideCanceledByUser:
      "errors.removingPassengersFromRideCanceledByUser",
    choosePassenger: "errors.choosePassenger",
    chooseStationFrom: "errors.chooseStationFrom",
    chooseStationTo: "errors.chooseStationTo",
    invalidPassengersInfoFromAPI: "errors.invalidPassengersInfoFromAPI",
    chooseDifferentStationToFrom: "errors.chooseDifferentStationToFrom",
    invalidStationFetched: "errors.invalidStationFetched",
    chooseStationToAdd: "errors.chooseStationToAdd",
    passengerNotAddedDryRunCheckError:
      "errors.passengerNotAddedDryRunCheckError",
    lockingStationNotConfirmedByUser: "errors.lockingStationNotConfirmedByUser",
    removePassengersFromRideCanceledByUser:
      "errors.removePassengersFromRideCanceledByUser",
    updatedRideCanceledByUser: "errors.updatedRideCanceledByUser",
    rideMovePassengersError: "errors.rideMovePassengersError",
    rideUpdateInPastNotPermitted: "errors.rideUpdateInPastNotPermitted",
    rideCreateInPastNotPermitted: "errors.rideCreateInPastNotPermitted",
    cannotRemovePassengersFromDifferentUnits:
      "errors.cannotRemovePassengersFromDifferentUnits",
    cannotRemovePassengersFromDifferentSites:
      "errors.cannotRemovePassengersFromDifferentSites",
    cannotMovePassengersFromDifferentUnits:
      "errors.cannotMovePassengersFromDifferentUnits",
    cannotMovePassengersFromDifferentSites:
      "errors.cannotMovePassengersFromDifferentSites",
    cannotMovePassengersFromDifferentUnitsAndSites:
      "errors.cannotMovePassengersFromDifferentUnitsAndSites",
    ignoringDurationLimitsAllowedForMlPaths:
      "ride.ignoringDurationLimitsAllowedForMlPaths",
    totalDurationExceeded: "ride.totalDurationExceeded",
    boardingSegmentDurationExceeded: "ride.boardingSegmentDurationExceeded",
    stationHasMissingData: "errors.stationHasMissingData",
    nearbyResultFetchingError: "errors.nearbyResultFetchingError",
    noChangesToSave: "ride.noChangesToSave",
    bookingsMismatchRouteTooltipFallback:
      "ride.bookingsMismatchRouteTooltipFallback",
    bookingsMismatchRouteBookingsMissingOnRide:
      "ride.bookingsMismatchRouteBookingsMissingOnRide",
    bookingsMismatchRoutePassengersNoRideBooking:
      "ride.bookingsMismatchRoutePassengersNoRideBooking",
    bookingsMismatchRideBookingsNotOnRoutePassengers:
      "ride.bookingsMismatchRideBookingsNotOnRoutePassengers",
    sendToSupplierSkippedBelowMinimumPassengers:
      "errors.sendToSupplierSkippedBelowMinimumPassengers",
    bulkRideSkippedNoPermission: "errors.bulkRideSkippedNoPermission",
    bulkAllRidesSkipped: "errors.bulkAllRidesSkipped",
    driverRestWindow: "errors.driverRestWindow",
  },
  course: {
    invalidCourseDragIdMismatch: "errors.invalidCourseDragIdMismatch",
    invalidCourseDragDataMismatch: "errors.invalidCourseDragDataMismatch",
    stationsNotRecountedSuccessfully: "errors.stationsNotRecountedSuccessfully",
    invalidCourseEditingSnapshot: "errors.invalidCourseEditingSnapshot",
    noStationToRebuild: "errors.noStationToRebuild",
    stationDoesntHavePassengers: "errors.stationDoesntHavePassengers",
  },
  booking: {
    missingPassenger: "errors.missingPassenger",
    errorOccurredWhenUpdatingBooking: "errors.errorOccurredWhenUpdatingBooking",
    wrongResponseTypeFromBookingCount:
      "errors.wrongResponseTypeFromBookingCount",
    failedToFetchPassengerStations: "errors.failedToFetchPassengerStations",
    unexpectedBookingCreateState: "errors.unexpectedBookingCreateState",
    bookingCreationProcessCanceledByUser:
      "errors.bookingCreationProcessCanceledByUser",
    noDatesSelectedForBookingCreation:
      "errors.noDatesSelectedForBookingCreation",
    invalidParametersForBookingCreation:
      "errors.invalidParametersForBookingCreation",
    areYouSureToAbortBookingCreation:
      "booking.bulk.areYouSureToAbortBookingCreation",
    processingBookingsHasConflicts:
      "booking.bulk.processingBookingsHasConflicts",
    processingBookings: "booking.bulk.processingBookings",
  },
  reports: {
    wrongResponseTypeFromReportCount: "errors.wrongResponseTypeFromReportCount",
    failedFetchingReports: "errors.failedFetchingReports",
    invalidTemplateId: "errors.invalidTemplateId",
    invalidReportFormData: "errors.invalidReportFormData",
    errorSavingReport: "errors.errorSavingReport",
    reportNameExists: "errors.reportNameExists",
    errorRemovingReport: "errors.errorRemovingReport",
    reportNotFound: "errors.reportNotFound",
    cantRemoveLastReportOfCategory: "errors.cantRemoveLastReportOfCategory",
  },
  auth: {
    csrfTokenMissingOrInvalid: "errors.csrfTokenMissingOrInvalid",
    incorrectUsernameOrPassword: "errors.incorrectUsernameOrPassword",
    tokenExpiredError: "errors.tokenExpiredError",
    errorWhileRefreshTokens: "errors.errorWhileRefreshTokens",
    authenticationFailure: "errors.authenticationFailure",
    recaptureFailure: "errors.recaptureFailure",
    microsoftAuthenticationFailure: "errors.microsoftAuthenticationFailure",
    OTPAuthenticationFailure: "errors.OTPAuthenticationFailure",
    errorWhileRequestOTP: "errors.errorWhileRequestOTP",
    resetPasswordRecaptureAuthenticationFailure:
      "errors.resetPasswordRecaptureAuthenticationFailure",
    tokenRefreshAuthenticationFailure:
      "errors.tokenRefreshAuthenticationFailure",
    noAppropriateAuthorizationScopeDataFound:
      "errors.noAppropriateAuthorizationScopeDataFound",
    unhandledErrorFetchingProfile: "errors.unhandledErrorFetchingProfile",
    failedFetchProfile: "errors.failedFetchProfile",
    failedUpdateProfile: "errors.failedUpdateProfile",
    passwordResetTokenHasExpired: "errors.passwordResetTokenHasExpired",
    passwordResetTokenInvalidOrUsed: "errors.passwordResetTokenInvalidOrUsed",
    passwordResetLinkMissing: "errors.passwordResetLinkMissing",
  },
  oauth: {
    requestNotFound: "errors.oauthRequestNotFound",
    requestExpired: "errors.oauthRequestExpired",
    freshLoginRequired: "errors.oauthFreshLoginRequired",
    companyNotEligible: "errors.oauthCompanyNotEligible",
    connectorDisabled: "errors.oauthConnectorDisabled",
    grantNotFound: "errors.oauthGrantNotFound",
  },
  passengers: {
    fetchActivePassengers: "errors.fetchActivePassengers",
    noPassengerStationFound: "errors.noPassengerStationFound",
  },
  incident: {
    closeNotAllowed: "errors.closeIncidentNotAllowed",
    failedCloseFromLiveMap: "errors.failedCloseIncidentFromLiveMap",
  },
  systemTags: {
    invalidTagName: "errors.invalidTagName",
    tagNotSaved: "errors.tagNotSaved",
  },
  helpTopics: {
    topicNotFound: "errors.helpTopicNotFound",
  },
  form: {
    multiSelectBoundTemplateInitialValueNotArray:
      "errors.multiSelectBoundTemplateInitialValueNotArray",
  },
  validation: {
    required: "validation.required",
    requiredCustomOneOf: "validation.requiredCustomOneOf",
    atLeastOneConditionRequired: "validation.atLeastOneConditionRequired",
    absenceCustomValidationParams: "errors.absenceCustomValidationParams",
    toTimeIsLowerThenFromTime: "validation.toTimeIsLowerThenFromTime",
    fromTimeIsBiggerThenToTime: "validation.fromTimeIsBiggerThenToTime",
    endTimeMustBeGreaterThenStartTime:
      "validation.endTimeMustBeGreaterThenStartTime",
    additionsValueIsNotRequired: "validation.additionsValueIsNotRequired",
    fromHasSameValue: "validation.fromHasSameValue",
    fromHasLowerValue: "validation.fromHasLowerValue",
    dateIsInvalid: "validation.dateIsInvalid",
  },
  notification: {
    errorGettingNotifications: "errors.errorGettingNotifications",
  },
  map: {
    getCoordinateByPlaceId: "errors.getCoordinateByPlaceId",
    searchPlacesByInput: "errors.searchPlacesByInput",
    searchAddressByGeo: "errors.searchAddressByGeo",
    getWalkingDistanceAndTime: "errors.getWalkingDistanceAndTime",
  },
  softValidation: {
    freezeTimeToCreateRide: "validation.softValidation.freezeTimeToCreateRide",
    freezeTimeToChangeRide: "validation.softValidation.freezeTimeToChangeRide",
    freezeTimeToCancelRide: "validation.softValidation.freezeTimeToCancelRide",
    rideRebuild: "validation.softValidation.RideRebuild",
    hubRideHasRelatedRideUpdate: "validation.softValidation.HubUpdate",
    hubRideHasRelatedRideDelete: "validation.softValidation.HubDelete",
    doneRidePriceRecalculate:
      "validation.softValidation.doneRidePriceRecalculate",
    flexRideWillBeMergedToDynamic:
      "validation.softValidation.FlexRideWillBeMergedToDynamic",
    flexRideWillBeMergedToDynamicStationMismatch:
      "validation.softValidation.FlexRideWillBeMergedToDynamicStationMismatch",
    flexRideWillBeMergedToDynamicTimeMismatch:
      "validation.softValidation.FlexRideWillBeMergedToDynamicTimeMismatch",
  },
  google: {
    errorUpdatingStationRoute: "errors.errorUpdatingStationRoute",
    errorCreatingStationRoute: "errors.errorCreatingStationRoute",
  },
  produce: {
    missingToken: "errors.missingToken",
    noActiveProduceRunning: "errors.noActiveProduceRunning",
    failedToAbort: "errors.failedToAbort",
    failedToFetchLogs: "errors.failedToFetchLogs",
    failedCreatingProduce: "errors.failedCreatingProduce",
    produceCanceledByUser: "errors.produceCanceledByUser",
    noBookingsFound: "errors.noBookingsFound",
    allBookingsAlreadyInProduction: "errors.allBookingsAlreadyInProduction",
    invalidParametersForFixedRideCreation:
      "errors.invalidParametersForFixedRideCreation",
    bookingsSkippedNotFoundRidesToJoin: "rideProduction.noMatchingRidesToJoin",
  },
  dataUpload: {
    failedToQueueRun: "errors.failedToQueueDataUploadRun",
    failedToLoadLog: "errors.failedToLoadDataUploadLog",
  },
  feedback: {
    failedToSendFeedbackToSupplier: "errors.failedToSendFeedbackToSupplier",
  },
  stationRoute: {
    noStationsInRoute: "ride.SAVE_ROUTE.NO_STATIONS_IN_ROUTE",
    stationRouteIsAlreadyDeleted: "ride.SAVE_ROUTE.ROUTE_IS_ALREADY_DELETED",
    noRouteToDelete: "ride.SAVE_ROUTE.NO_ROUTE_TO_DELETE",
    errorDeletingRoute: "ride.SAVE_ROUTE.ERROR_DELETING_ROUTE",
    errorSavingRoute: "ride.SAVE_ROUTE.ERROR_SAVING_ROUTE",
    customizedPathAlreadyExists: "stationRoute.CUSTOMIZED_PATH_ALREADY_EXISTS",
  },
  stationTiming: {
    notEnoughStations: "errors.stationTimingNotEnoughStations",
    noMeasurementSelected: "stationTiming.NO_MEASUREMENT_SELECTED",
    statsNotLoaded: "stationTiming.STATS_NOT_LOADED",
  },
  landing: {
    loadingFailed: "landing.loadingFailed",
    passengerNoFound: "errors.oneOrMoreDetailsAreIncorrect",
    passengerIsNotEligible: "errors.passengerIsNotEligible",
    passengerIsProbablyBlocked: "errors.passengerIsProbablyBlocked",
    passengerAlreadyRegistered: "errors.passengerAlreadyRegistered",
  },
  auditLog: {
    notFoundAuditLogRecords: "auditLog.notFoundAuditLogRecords",
  },
  processes: {
    errorFetchingProcesses: "process.Error fetching processes",
    errorFetchingProcessesCount: "process.Error fetching processes count",
    notFoundProcessRecords: "process.notFoundProcessRecords",
    processCanceledByUser: "errors.processCanceledByUser",
  },
  ai: {
    occasionalAIResponseFailure: "errors.occasionalAIResponseFailure",
  },
  priceRate: {
    missingSupplier: "errors.priceRateMissingSupplier",
    missingVehicleType: "errors.priceRateMissingVehicleType",
    missingSourceArea: "errors.priceRateMissingSourceArea",
    missingDestinationArea: "errors.priceRateMissingDestinationArea",
    vehicleTypeWrongSupplier: "errors.priceRateVehicleTypeWrongSupplier",
    vehicleTypeHasNoSupplier: "errors.priceRateVehicleTypeHasNoSupplier",
  },
} as const;
